<template>
    <ContentOrLoading>
        <div v-if="abonos_por_cp" class="table-responsive m-0">
            <span style="font-size: 17.6px; font-weight: 400; color: rgb(68, 68, 68); font-family: Oswald, sans-serif; margin: 5px; padding: 3px;">Total de abonos por CP</span>
            <div class="table-responsive">
                <b-table hover :items="abonos_por_cp" :fields="fields" id="cp-table" :per-page="perPage" :current-page="currentPage">
                    <template #cell(cp)="data">
                        {{ data.item.cp ? data.item.cp : '-' }}
                    </template>
                    <template #cell(provincia)="data">
                        {{ data.item.provincia_nombre ? data.item.provincia_nombre : '-' }}
                    </template>
                    <template #cell(poblacion)="data">
                        {{ data.item.localidad_nombre ? data.item.localidad_nombre : '-' }}
                    </template>
                    <template #cell(count)="data">
                        {{ data.item.total }}
                    </template>
                </b-table>
            </div>
            <b-pagination :per-page="perPage" aria-controls="cp-table" v-model="currentPage" :total-rows="abonos_por_cp.length" size="sm"/>
        </div>
    </ContentOrLoading>
</template>

<script>
    export default {
        props: ['lista_id'],
        data() {
            return {
                fields: [
                    { key: 'cp', label: 'CP/ZIP CODE', class: 'cp'},
                    { key: 'provincia', label: 'Provincia', class: 'provincia'},
                    { key: 'poblacion', label: 'Poblacion', class: 'poblacion'},
                    { key: 'total', label: 'Total', class: 'total', 'sortable': true },
                ],
                cpToInfo: {},
                perPage: 10,
                currentPage: 1,
                abonos_por_cp: null,
                loading: false
            }
        },
        created() {
            this.getTotalAbonosPorCp();
        },
        methods: {
            getTotalAbonosPorCp() {
                this.loading = true;

                const params = {
                    filters : {},
                    lista_id: this.lista_id
                };
                this.$store.dispatch(this.config.getVuexAlias('back.abonos.informe.total-abonos-por-cp'), params).then(res => {
                    this.abonos_por_cp = res.data;
                }).finally(() => this.loading = false);
            },
        }
    }
</script>